module.exports = __webpack_public_path__ + "img/item2.03248284.svg";